import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, filter, retry, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import jwt_decode from 'jwt-decode';
import { NavigationEnd, NavigationExtras } from '@angular/router';
import { DeviceService } from './device.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isAuthenticate: boolean = false;
  private endpoint = environment.endpoint;
  private url = this.endpoint;

  isTimeout: boolean = true
  currentRoute: any = ''
  closed$ = new Subject<any>();

  constructor(private httpclient: HttpClient,
    private devicesrvc: DeviceService,
    private router: Router) {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.closed$)
      ).subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.currentRoute = event['url'];
          // // console.log("this.currentRoute", this.currentRoute)
          if (this.currentRoute !== '/login' && this.currentRoute !== '/') {
            localStorage.setItem("lastPage", this.currentRoute)
          } else {
            this.isAuthenticate = false
            this.router.navigate(['/login'])
          }
        }
      })
  }

  async ifLoggedIn() {
    // if (localStorage.getItem("RememberMe")) {
    //   let isCheck = JSON.parse(localStorage.getItem("RememberMe"))
    //   // // console.log("isCheck", isCheck)
    //   if (isCheck) {

    //   } else {
    //     localStorage.removeItem("USER_INFO")
    //     this.isAuthenticate = false
    //     this.router.navigate(['/login'])
    //   }
    // }

    if (localStorage.getItem("USER_INFO")) {
      let user = JSON.parse(localStorage.getItem("USER_INFO"))
      // // console.log("i got called ifLoggedIn", user)
      if (user.validationStatus === 'pending') {
        this.isAuthenticate = false
        this.router.navigate(['/login'])
      } else {
        this.isAuthenticate = true;
        let lastPageIs: any
        if (localStorage.getItem('lastPage')) {
          lastPageIs = localStorage.getItem('lastPage')
        }
        this.router.navigate([lastPageIs])
        // // console.log("hey i got called", lastPageIs)
      }
    }

  }

  userLogin(info: any) {
    // // console.log("userlogin", info);
    this.isTimeout = true
    let toast: any = {}
    return new Promise(resolve => {

      this.httpclient.post(this.url + '/user/token', JSON.stringify(info))
        .subscribe(async response => {
          this.isTimeout = false
          let loginresponse = await response
          // // console.log("hello", response, loginresponse["success"]);
          if (loginresponse["success"]) {
            localStorage.setItem('authToken', loginresponse['data'].token)
            // localStorage.setItem('authToken', loginresponse['data'].token)
            let userData: any = this.decodeToken(loginresponse['data'].token);
            // // console.log("userData", userData);
            if (userData["type"] === "client") {
              localStorage.setItem('USER_INFO', JSON.stringify(userData))
              console.log("im here sir", userData);
              var PATTERN = 'dcf80ba2-db51-4f30-9eca-819fbe72ebe3',
                filtered = userData.roleIds.filter(function (str) { return str.includes(PATTERN); });
              localStorage.setItem("isCorporateMain", filtered.length)
              if (!userData.hasOwnProperty("softDelete")) {
                if (userData["validationStatus"] === "approved") {
                  // // console.log("create device token", userData, "userData.softDelete", userData.hasOwnProperty("softDelete"));
                  if (userData["isActive"]) {
                    this.createDeviceTokenV2(userData)
                      .then(response => {
                        // // console.log("createDeviceTokenV2", response);
                        resolve(response)
                      })
                  }
                } else {
                  resolve(userData["validationStatus"])
                }
              } else {
                // // console.log("im here");
                if (userData["softDelete"]) {
                  let toast: any = {}
                  toast.header = "Invalid Username/Pasword",
                    toast.msg = "The username or password you entered is incorrect. Please try again.",
                    toast.class = 'toast-danger'
                  // this.appErrorNotify(toast)
                  localStorage.clear()
                  resolve(false)
                } else {
                  if (userData["validationStatus"] === "approved") {
                    // // console.log("create device token", userData, "userData.softDelete", userData.hasOwnProperty("softDelete"));
                    if (userData["isActive"]) {
                      this.createDeviceTokenV2(userData)
                        .then(response => {
                          // // console.log("createDeviceTokenV2", response);
                          resolve(response)
                        })
                      // resolve(true)
                    }
                    // call create device token
                  } else {
                    resolve("pending")
                  }
                }
              }
            } else {
              let toast = {
                header: "Invalid Username/Pasword",
                msg: "The username or password you entered is incorrect. Please try again.",
                class: 'toast-danger'
              }
              // this.appErrorNotify(toast)
              // this.loaderSrvc.dismiss();
              // Vin Added Validation 11/02/2022
            }
          }
        }, err => {
          this.isTimeout = false
          // // console.log("131 im here error", err);
          if (err["error"].errors) {
            if (err["error"].errors.base[0] == "invalid credentials") {
              toast.header = "Invalid Username/Pasword",
                toast.msg = "The username or password you entered is incorrect. Please try again.",
                toast.class = 'toast-danger'
            } else {
              toast.header = "Oops!",
                toast.msg = "if this message stills encounter please contact ecarga admin.",
                toast.class = 'toast-danger'
            }
          } else {
            toast.header = "Invalid Username/Pasword",
              toast.msg = "The username or password you entered is incorrect. Please try again.",
              toast.class = 'toast-danger'
            // this.loaderSrvc.dismiss()
          }
          // this.appErrorNotify(toast)
          resolve(false)
        })

      setTimeout(() => {
        if (this.isTimeout) {
          this.warningMessage()
          resolve(false)
        }
      }, 60000)
    })
  }

  userChecker(info) {
    // // console.log("userChecker", info);
    return new Promise(resolve => {
      let update_End_point = this.endpoint.split('/v1.0')
      let url_env = environment.type === 'stg' ? update_End_point[0] : this.endpoint
      const url = url_env + '/user/check-user'
      // // console.log("userChecker", url);

      this.httpclient.post(url, info)
        .subscribe(async response => {
          // // console.log("userChecker", response);
          if (response["success"]) {
            if (!response["data"].isOld) {
              // new layer
              // if ischangepass is true pass else false
              resolve(true) // new
            } else {
              if (response["data"].isValidContactNumber) {
                // // console.log("data", response["data"]);
                resolve(response["data"]) // old
              } else {

                let navigationExtras: NavigationExtras = {
                  queryParams: {
                    isValidcontactNumber: false
                  }
                };
                // this.router.navigate(['/session'], navigationExtras);
              }
            }
          }
        }, err => {
          // // console.log("err", err);
          resolve(true) // old
        })
    })
  }

  getUserInfo(token) {
    return new Promise(resolve => {
      const url = this.url + '/user/current-user';
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        })
      };
      this.httpclient.get(url, httpOptions)
        .subscribe(response => {
          if (response["success"]) {
            resolve(response)
          }
        }, err => {
          // // console.log("logout app auth token expired", err.error.errors);
          err.error.errors.base.forEach(item => {
            let result = item.includes("does not exist");
            console.log("result", result)
            if (result) {
              this.isAuthenticate = false
              this.router.navigate(['/login'])
              localStorage.setItem("lastPage", "")
            }
            if (item === 'jwt expired' || item === 'jwt malformed' || item === 'invalid token') {
              //logout web app
              this.isAuthenticate = false
              this.router.navigate(['/login'])
              localStorage.setItem("lastPage", "")
            }
          });

          // if(result.length > 0){
          //   this.forceLogout()
          // }
          resolve(false)
        })
    })
  }

  verifyV2(mobileOtp) {
    return new Promise(resolve => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      };
      let params = {
        mobileOtp: mobileOtp
      }
      this.httpclient.post(this.url + '/user/get-forgot-password-token', params, httpOptions)
        .subscribe(response => {
          // // console.log("response", response);
          if (response["success"]) {
            resolve(response)
          } else {
            resolve(false)
          }
        }, err => {
          // // console.log("verify", err)
          let msg = err["error"].errors.mobileOtp[0] === 'account not found' ? 'OTP is not valid please try again.' : err["error"].errors.mobileOtp
          // this.errorMessage(msg)
          resolve(false)
        });
    }).catch(err => {
      // // console.log(err)
    })
  }

  decodeToken(token: string) {
    try {
      return jwt_decode(token);
    } catch (err) {
      return null;
    }
  }

  createDeviceTokenV2(userInfo: any) {
    return new Promise(resolve => {

      // // console.log("userInfo", userInfo);
      let deviceObj = localStorage.getItem("deviceInfo")
      let deviceInfo = JSON.parse(deviceObj)
      // // console.log("deviceInfo", deviceInfo)


      deviceInfo.type = userInfo.type ? userInfo.type : "client"
      deviceInfo.username = userInfo.username ? userInfo.username : ""
      // // console.log("deviceInfo", deviceInfo, "userInfo", userInfo);
      //Sending Device Token To API
      this.devicesrvc.create(deviceInfo, localStorage.getItem('authToken'))
        .subscribe(res => {
          // // console.log("create device", res);
          // let appLogindate = moment(new Date(), "DD/MM/YYYY hh:mm:ss").unix();
          // this.storage.set('appLogin', appLogindate)
          // this.authState.next(true);
          // this.router.navigate(['/ecarga'])
          this.isAuthenticate = true
          this.router.navigate(['/jobrequest'])
          resolve(true)
        }, err => {
          // // console.log("platform", err);
          // when running in webbrowser there's no token can be generated so we need to bypass the login / in devices this will not work
          resolve(true)
          // this.authState.next(true);
          this.isAuthenticate = true
          this.router.navigate(['/jobrequest'])
        })
    })
  }

  warningMessage() {
    Swal.fire({
      title: "Oops!",
      text: "We are having a problem at the moment please try again.",
      icon: "warning",
      confirmButtonText: "Close",
      customClass: "swal-small",
      width: "20rem",
    }).then((result) => { });
  }

}
